import { render, staticRenderFns } from "./d-comment-box-guest.vue?vue&type=template&id=1dd9c5e2&scoped=true&"
import script from "./d-comment-box-guest.vue?vue&type=script&lang=js&"
export * from "./d-comment-box-guest.vue?vue&type=script&lang=js&"
import style0 from "./d-comment-box-guest.vue?vue&type=style&index=0&id=1dd9c5e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd9c5e2",
  null
  
)

export default component.exports